import { toDisplayString as _toDisplayString, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, vModelSelect as _vModelSelect, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, vModelRadio as _vModelRadio, resolveComponent as _resolveComponent, vModelCheckbox as _vModelCheckbox } from "vue"

const _hoisted_1 = { class: "form-list-wrapper" }
const _hoisted_2 = { class: "card" }
const _hoisted_3 = { class: "card-head pb-3" }
const _hoisted_4 = { class: "card-title" }
const _hoisted_5 = { class: "form-wrap" }
const _hoisted_6 = {
  class: "row",
  id: "filterFormList"
}
const _hoisted_7 = { class: "col-md-3 col-6" }
const _hoisted_8 = { class: "form-group" }
const _hoisted_9 = { for: "" }
const _hoisted_10 = { class: "col-md-3 col-6" }
const _hoisted_11 = { class: "form-group" }
const _hoisted_12 = {
  for: "",
  class: "to-upper"
}
const _hoisted_13 = { class: "col-md-3 col-6" }
const _hoisted_14 = { class: "form-group" }
const _hoisted_15 = {
  for: "",
  class: "to-upper"
}
const _hoisted_16 = { class: "col-md-3 col-6" }
const _hoisted_17 = { class: "form-group" }
const _hoisted_18 = {
  for: "",
  class: "to-upper"
}
const _hoisted_19 = {
  class: "tag-wrapper",
  id: "popularTagsForTemplateSearch"
}
const _hoisted_20 = { key: 0 }
const _hoisted_21 = /*#__PURE__*/_createVNode("hr", null, null, -1)
const _hoisted_22 = { class: "title mb-3" }
const _hoisted_23 = {
  class: "row",
  id: "displayFormBy"
}
const _hoisted_24 = { class: "col-md-4" }
const _hoisted_25 = { class: "form-group" }
const _hoisted_26 = {
  for: "all",
  class: "ml-1"
}
const _hoisted_27 = { class: "col-md-4 col-6" }
const _hoisted_28 = { class: "form-group" }
const _hoisted_29 = {
  for: "sent_by_me",
  class: "ml-1"
}
const _hoisted_30 = { class: "col-md-4 col-6" }
const _hoisted_31 = { class: "form-group" }
const _hoisted_32 = {
  for: "sent_to_me",
  class: "ml-1"
}
const _hoisted_33 = { class: "row align-items-center" }
const _hoisted_34 = { class: "col-6" }
const _hoisted_35 = { class: "title mb-0" }
const _hoisted_36 = { class: "col-6" }
const _hoisted_37 = { class: "button-header text-right mt-0" }
const _hoisted_38 = /*#__PURE__*/_createVNode("svg", {
  class: "svg-inline--fa fa-plus fa-w-14",
  "aria-hidden": "true",
  focusable: "false",
  "data-prefix": "fas",
  "data-icon": "plus",
  role: "img",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 448 512",
  "data-fa-i2svg": ""
}, [
  /*#__PURE__*/_createVNode("path", {
    fill: "currentColor",
    d: "M416 208H272V64c0-17.67-14.33-32-32-32h-32c-17.67 0-32 14.33-32 32v144H32c-17.67 0-32 14.33-32 32v32c0 17.67 14.33 32 32 32h144v144c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32V304h144c17.67 0 32-14.33 32-32v-32c0-17.67-14.33-32-32-32z"
  })
], -1)
const _hoisted_39 = {
  class: "table-responsive my-3",
  id: "formListFiltered"
}
const _hoisted_40 = { class: "table table-shadowed mb-0 table-bordered" }
const _hoisted_41 = { class: "table-primary text-nowrap" }
const _hoisted_42 = { scope: "col" }
const _hoisted_43 = { scope: "col" }
const _hoisted_44 = { scope: "col" }
const _hoisted_45 = { scope: "col" }
const _hoisted_46 = { scope: "col" }
const _hoisted_47 = { key: 0 }
const _hoisted_48 = {
  key: 0,
  href: "javascript:void(0)"
}
const _hoisted_49 = /*#__PURE__*/_createVNode("i", {
  class: "fa fa-file-invoice mr-2",
  title: "Digitized document"
}, null, -1)
const _hoisted_50 = {
  key: 1,
  href: "javascript:void(0)"
}
const _hoisted_51 = { class: "block-list email-list" }
const _hoisted_52 = { key: 0 }
const _hoisted_53 = { key: 0 }
const _hoisted_54 = { class: "table-button" }
const _hoisted_55 = /*#__PURE__*/_createVNode("i", { class: "fas fa-edit" }, null, -1)
const _hoisted_56 = /*#__PURE__*/_createVNode("i", { class: "fa fa-paper-plane" }, null, -1)
const _hoisted_57 = /*#__PURE__*/_createVNode("i", { class: "fas fa-eye" }, null, -1)
const _hoisted_58 = { class: "my-3" }
const _hoisted_59 = { "aria-label": "Page navigation example" }
const _hoisted_60 = { class: "send-to modal-wrap xl-size" }
const _hoisted_61 = {
  class: "modal fade",
  id: "formPreviewModal",
  tabindex: "-1",
  role: "dialog",
  "aria-labelledby": "exampleModalLabel",
  "aria-hidden": "true"
}
const _hoisted_62 = {
  class: "modal-dialog modal-dialog-centered modal-dialog-scrollable",
  role: "document"
}
const _hoisted_63 = { class: "modal-content" }
const _hoisted_64 = { class: "modal-header" }
const _hoisted_65 = { class: "d-block" }
const _hoisted_66 = {
  class: "modal-title",
  id: "exampleModalLabel"
}
const _hoisted_67 = { class: "text-muted" }
const _hoisted_68 = /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }, "×", -1)
const _hoisted_69 = { class: "modal-body" }
const _hoisted_70 = { class: "form-wrap pt-0" }
const _hoisted_71 = { disabled: "" }
const _hoisted_72 = {
  key: 6,
  class: "form-block text-field"
}
const _hoisted_73 = {
  key: 0,
  class: "readonly-title"
}
const _hoisted_74 = {
  key: 7,
  class: "form-block text-field"
}
const _hoisted_75 = { class: "row" }
const _hoisted_76 = { class: "col-md-2" }
const _hoisted_77 = /*#__PURE__*/_createVNode("p", null, [
  /*#__PURE__*/_createVNode("i", { class: "fas fa-file-signature fa-3x" })
], -1)
const _hoisted_78 = {
  key: 0,
  class: "readonly-title"
}
const _hoisted_79 = { class: "modal-footer justify-content-between" }
const _hoisted_80 = {
  key: 0,
  class: "form-sender"
}
const _hoisted_81 = { class: "mb-0" }
const _hoisted_82 = /*#__PURE__*/_createVNode("i", { class: "fas fa-user mr-1" }, null, -1)
const _hoisted_83 = { key: 0 }
const _hoisted_84 = { class: "modal-wrap form-edit xl-size" }
const _hoisted_85 = {
  class: "modal fade",
  id: "editSelectedElementOfCreateNewForm",
  tabindex: "-1",
  role: "dialog",
  "aria-labelledby": "exampleModalLabel",
  "aria-hidden": "true"
}
const _hoisted_86 = {
  class: "modal-dialog modal-dialog-centered",
  role: "document"
}
const _hoisted_87 = { class: "modal-content" }
const _hoisted_88 = { class: "modal-header" }
const _hoisted_89 = {
  key: 0,
  class: "modal-title",
  id: "exampleModalLabel"
}
const _hoisted_90 = {
  key: 1,
  class: "modal-title",
  id: "exampleModalLabel"
}
const _hoisted_91 = /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }, "×", -1)
const _hoisted_92 = { class: "modal-body" }
const _hoisted_93 = { class: "form-wrap pt-0" }
const _hoisted_94 = { key: 0 }
const _hoisted_95 = { class: "form-group" }
const _hoisted_96 = { for: "inputPassword" }
const _hoisted_97 = { class: "form-group" }
const _hoisted_98 = {
  for: "inputPassword",
  class: "to-upper"
}
const _hoisted_99 = { key: 1 }
const _hoisted_100 = { class: "form-group" }
const _hoisted_101 = { for: "inputPassword" }
const _hoisted_102 = { key: 2 }
const _hoisted_103 = { class: "form-group" }
const _hoisted_104 = { for: "inputPassword" }
const _hoisted_105 = { key: 3 }
const _hoisted_106 = { class: "form-wrap pt-0" }
const _hoisted_107 = { class: "form-group" }
const _hoisted_108 = { for: "inputPassword" }
const _hoisted_109 = {
  key: 0,
  class: "form-group"
}
const _hoisted_110 = { for: "inputPassword" }
const _hoisted_111 = { class: "col-lg-1" }
const _hoisted_112 = { class: "form-check" }
const _hoisted_113 = { class: "col-lg-5" }
const _hoisted_114 = { class: "col-lg-5" }
const _hoisted_115 = { class: "col-lg-1 pl-0" }
const _hoisted_116 = /*#__PURE__*/_createVNode("i", { class: "fas fa-times" }, null, -1)
const _hoisted_117 = { class: "text-right" }
const _hoisted_118 = /*#__PURE__*/_createVNode("i", { class: "fas fa-plus" }, null, -1)
const _hoisted_119 = { key: 4 }
const _hoisted_120 = { class: "form-wrap pt-0" }
const _hoisted_121 = { class: "form-group" }
const _hoisted_122 = { for: "inputPassword" }
const _hoisted_123 = {
  key: 0,
  class: "form-group"
}
const _hoisted_124 = { for: "inputPassword" }
const _hoisted_125 = { class: "col-lg-1" }
const _hoisted_126 = { class: "form-check" }
const _hoisted_127 = { class: "col-lg-5" }
const _hoisted_128 = { class: "col-lg-5" }
const _hoisted_129 = { class: "col-lg-1 pl-0" }
const _hoisted_130 = /*#__PURE__*/_createVNode("i", { class: "fas fa-times" }, null, -1)
const _hoisted_131 = { class: "text-right" }
const _hoisted_132 = /*#__PURE__*/_createVNode("i", { class: "fas fa-plus" }, null, -1)
const _hoisted_133 = { key: 5 }
const _hoisted_134 = { class: "form-wrap pt-0" }
const _hoisted_135 = { class: "form-group" }
const _hoisted_136 = { for: "inputPassword" }
const _hoisted_137 = {
  key: 0,
  class: "form-group"
}
const _hoisted_138 = { for: "inputPassword" }
const _hoisted_139 = { class: "col-lg-1" }
const _hoisted_140 = { class: "form-check" }
const _hoisted_141 = { class: "col-lg-5" }
const _hoisted_142 = { class: "col-lg-5" }
const _hoisted_143 = { class: "col-lg-1 pl-0" }
const _hoisted_144 = /*#__PURE__*/_createVNode("i", { class: "fas fa-times" }, null, -1)
const _hoisted_145 = { class: "text-right" }
const _hoisted_146 = /*#__PURE__*/_createVNode("i", { class: "fas fa-plus" }, null, -1)
const _hoisted_147 = { class: "modal-footer" }
const _hoisted_148 = { class: "modal-wrap xl-size view-form" }
const _hoisted_149 = {
  class: "modal fade",
  id: "formview",
  tabindex: "-1",
  role: "dialog",
  "aria-labelledby": "exampleModalLabel",
  "aria-hidden": "true"
}
const _hoisted_150 = {
  class: "modal-dialog modal-dialog-centered",
  role: "document"
}
const _hoisted_151 = { class: "modal-content" }
const _hoisted_152 = { class: "modal-header" }
const _hoisted_153 = { class: "d-block" }
const _hoisted_154 = {
  class: "modal-title",
  id: "exampleModalLabel"
}
const _hoisted_155 = /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }, "×", -1)
const _hoisted_156 = { class: "modal-body bg-light" }
const _hoisted_157 = { class: "row equal-height-div" }
const _hoisted_158 = { class: "col-lg-8 equal-height-lg-div" }
const _hoisted_159 = {
  class: "nav nav-tabs",
  id: "myTab",
  role: "tablist"
}
const _hoisted_160 = { class: "nav-item" }
const _hoisted_161 = {
  class: "nav-link active to-upper",
  id: "home-tab",
  "data-toggle": "tab",
  href: "#home",
  role: "tab",
  "aria-controls": "home",
  "aria-selected": "true"
}
const _hoisted_162 = { class: "nav-item" }
const _hoisted_163 = {
  class: "nav-link",
  id: "profile-tab",
  "data-toggle": "tab",
  href: "#profile",
  role: "tab",
  "aria-controls": "profile",
  "aria-selected": "false"
}
const _hoisted_164 = {
  class: "tab-content",
  id: "myTabContent"
}
const _hoisted_165 = {
  class: "tab-pane fade show active",
  id: "home",
  role: "tabpanel",
  "aria-labelledby": "home-tab"
}
const _hoisted_166 = { disabled: "" }
const _hoisted_167 = { class: "form-wrap pt-0" }
const _hoisted_168 = {
  class: "tab-pane fade",
  id: "profile",
  role: "tabpanel",
  "aria-labelledby": "profile-tab"
}
const _hoisted_169 = {
  key: 0,
  class: "form-wrap"
}
const _hoisted_170 = { disabled: "" }
const _hoisted_171 = {
  key: 1,
  class: "empty-holder dashed-box bg-white mb-3 align-items-center m-3"
}
const _hoisted_172 = { class: "p-5 text-center w-100" }
const _hoisted_173 = { class: "empty-channel w-100" }
const _hoisted_174 = /*#__PURE__*/_createVNode("div", { class: "icon-wrapper" }, [
  /*#__PURE__*/_createVNode("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    class: "bi bi-exclamation-circle",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /*#__PURE__*/_createVNode("path", {
      "fill-rule": "evenodd",
      d: "M2.678 11.894a1 1 0 0 1 .287.801 10.97 10.97 0 0 1-.398 2c1.395-.323 2.247-.697 2.634-.893a1 1 0 0 1 .71-.074A8.06 8.06 0 0 0 8 14c3.996 0 7-2.807 7-6 0-3.192-3.004-6-7-6S1 4.808 1 8c0 1.468.617 2.83 1.678 3.894zm-.493 3.905a21.682 21.682 0 0 1-.713.129c-.2.032-.352-.176-.273-.362a9.68 9.68 0 0 0 .244-.637l.003-.01c.248-.72.45-1.548.524-2.319C.743 11.37 0 9.76 0 8c0-3.866 3.582-7 8-7s8 3.134 8 7-3.582 7-8 7a9.06 9.06 0 0 1-2.347-.306c-.52.263-1.639.742-3.468 1.105z"
    }),
    /*#__PURE__*/_createVNode("path", {
      "fill-rule": "evenodd",
      d: "M4 5.5a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5zM4 8a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7A.5.5 0 0 1 4 8zm0 2.5a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5z"
    })
  ])
], -1)
const _hoisted_175 = { class: "text-center" }
const _hoisted_176 = {
  key: 0,
  class: "mb-3"
}
const _hoisted_177 = {
  key: 1,
  class: "mb-3"
}
const _hoisted_178 = { key: 2 }
const _hoisted_179 = { class: "col-lg-4 equal-height-lg-div" }
const _hoisted_180 = { class: "form-wrap pt-0 mb-3" }
const _hoisted_181 = { class: "search-wrap" }
const _hoisted_182 = /*#__PURE__*/_createVNode("i", { class: "fas fa-search" }, null, -1)
const _hoisted_183 = {
  key: 0,
  class: "vertical-nav-wrap"
}
const _hoisted_184 = { class: "member-list form-response" }
const _hoisted_185 = {
  key: 1,
  src: "https://dummyimage.com/35x35/c9c9c9/363636",
  alt: ""
}
const _hoisted_186 = { class: "modal-footer justify-content-between" }
const _hoisted_187 = { class: "form-sender" }
const _hoisted_188 = { class: "mb-0" }
const _hoisted_189 = /*#__PURE__*/_createVNode("i", { class: "fas fa-user mr-1" }, null, -1)
const _hoisted_190 = /*#__PURE__*/_createVNode("span", null, "12-12-2020", -1)
const _hoisted_191 = { class: "modal-wrap xl-size" }
const _hoisted_192 = {
  class: "modal fade",
  id: "responseModal",
  tabindex: "-1",
  "aria-labelledby": "exampleModalLabel",
  "aria-hidden": "true"
}
const _hoisted_193 = { class: "modal-dialog modal-dialog-centered modal-dialog-scrollable" }
const _hoisted_194 = { class: "modal-content" }
const _hoisted_195 = { class: "modal-header" }
const _hoisted_196 = {
  class: "modal-title",
  id: "exampleModalLabel"
}
const _hoisted_197 = /*#__PURE__*/_createVNode("button", {
  type: "button",
  class: "close",
  "data-dismiss": "modal",
  "aria-label": "Close"
}, [
  /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }, "×")
], -1)
const _hoisted_198 = { class: "modal-body" }
const _hoisted_199 = { class: "form-group" }
const _hoisted_200 = {
  key: 0,
  class: "form-group"
}
const _hoisted_201 = { for: "" }
const _hoisted_202 = {
  key: 1,
  class: "form-group"
}
const _hoisted_203 = { for: "" }
const _hoisted_204 = {
  key: 2,
  class: "form-group"
}
const _hoisted_205 = { for: "" }
const _hoisted_206 = {
  key: 3,
  class: "form-group"
}
const _hoisted_207 = { class: "d-inline-block ml-2" }
const _hoisted_208 = {
  key: 4,
  class: "form-group"
}
const _hoisted_209 = { class: "modal-footer" }
const _hoisted_210 = {
  type: "button",
  class: "btn secondary-btn",
  "data-dismiss": "modal"
}
const _hoisted_211 = { class: "modal-wrap default-modal" }
const _hoisted_212 = {
  class: "modal fade",
  "data-backdrop": "static",
  "data-keyboard": "false",
  id: "sendoption",
  tabindex: "-1",
  "aria-labelledby": "exampleModalLabel",
  "aria-hidden": "true"
}
const _hoisted_213 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_214 = { class: "modal-content" }
const _hoisted_215 = { class: "modal-header" }
const _hoisted_216 = /*#__PURE__*/_createVNode("svg", {
  class: "svg-inline--fa fa-chevron-left fa-w-10",
  "aria-hidden": "true",
  focusable: "false",
  "data-prefix": "fas",
  "data-icon": "chevron-left",
  role: "img",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 320 512",
  "data-fa-i2svg": ""
}, [
  /*#__PURE__*/_createVNode("path", {
    fill: "currentColor",
    d: "M34.52 239.03L228.87 44.69c9.37-9.37 24.57-9.37 33.94 0l22.67 22.67c9.36 9.36 9.37 24.52.04 33.9L131.49 256l154.02 154.75c9.34 9.38 9.32 24.54-.04 33.9l-22.67 22.67c-9.37 9.37-24.57 9.37-33.94 0L34.52 272.97c-9.37-9.37-9.37-24.57 0-33.94z"
  })
], -1)
const _hoisted_217 = { class: "d-block" }
const _hoisted_218 = {
  class: "modal-title",
  id: "exampleModalLabel"
}
const _hoisted_219 = /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }, "×", -1)
const _hoisted_220 = { class: "modal-body" }
const _hoisted_221 = { class: "form-wrap pt-0" }
const _hoisted_222 = { class: "form-group" }
const _hoisted_223 = { for: "exampleInputEmail1" }
const _hoisted_224 = { class: "form-group" }
const _hoisted_225 = { for: "exampleInputEmail1" }
const _hoisted_226 = { class: "form-group" }
const _hoisted_227 = { for: "exampleInputEmail1" }
const _hoisted_228 = { class: "mb-0" }
const _hoisted_229 = /*#__PURE__*/_createVNode("i", { class: "fas fa-times-circle" }, null, -1)
const _hoisted_230 = { class: "form-group" }
const _hoisted_231 = { for: "" }
const _hoisted_232 = { class: "modal-footer d-block" }
const _hoisted_233 = { class: "row align-items-end no-gutters" }
const _hoisted_234 = { class: "col-lg-6" }
const _hoisted_235 = { class: "share-form-block form-inline" }
const _hoisted_236 = {
  for: "",
  class: "mb-1 mr-2"
}
const _hoisted_237 = /*#__PURE__*/_createVNode("i", { class: "fas fa-lock mb-1 mr-2" }, null, -1)
const _hoisted_238 = {
  key: 0,
  class: "form-wrap pt-0"
}
const _hoisted_239 = { class: "tooltip-block" }
const _hoisted_240 = /*#__PURE__*/_createVNode("i", { class: "far fa-question-circle ml-2" }, null, -1)
const _hoisted_241 = { class: "tooltip-msg" }
const _hoisted_242 = { class: "mb-0" }
const _hoisted_243 = { class: "col-lg-6" }
const _hoisted_244 = { class: "col-button" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_EmptyData = _resolveComponent("EmptyData")
  const _component_v_pagination = _resolveComponent("v-pagination")
  const _component_TitleComponent = _resolveComponent("TitleComponent")
  const _component_TextBoxComponent = _resolveComponent("TextBoxComponent")
  const _component_RadioButtonComponent = _resolveComponent("RadioButtonComponent")
  const _component_SelectOption = _resolveComponent("SelectOption")
  const _component_CheckBox = _resolveComponent("CheckBox")
  const _component_TextArea = _resolveComponent("TextArea")
  const _component_ErrorList = _resolveComponent("ErrorList")
  const _component_UpgradeSubscriptionModal = _resolveComponent("UpgradeSubscriptionModal")

  return (_openBlock(), _createBlock("div", null, [
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _createVNode("div", _hoisted_3, [
          _createVNode("h1", _hoisted_4, _toDisplayString(_ctx.$t('my_templates')), 1)
        ]),
        _createVNode("div", _hoisted_5, [
          _createVNode("div", _hoisted_6, [
            _createVNode("div", _hoisted_7, [
              _createVNode("div", _hoisted_8, [
                _createVNode("label", _hoisted_9, _toDisplayString(_ctx.$t('search_form')), 1),
                _withDirectives(_createVNode("input", {
                  type: "text",
                  class: "form-control",
                  placeholder: _ctx.$t('search_by_name'),
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.state.searchBy = $event)),
                  onKeyup: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.getAccountFormList && _ctx.getAccountFormList(...args)))
                }, null, 40, ["placeholder"]), [
                  [_vModelText, _ctx.state.searchBy]
                ])
              ])
            ]),
            _createVNode("div", _hoisted_10, [
              _createVNode("div", _hoisted_11, [
                _createVNode("label", _hoisted_12, _toDisplayString(_ctx.$t('projects')), 1),
                _withDirectives(_createVNode("select", {
                  disabled: !_ctx.state.projectList || !_ctx.state.projectList.length,
                  class: "custom-select form-control",
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.state.filter.projectId = $event)),
                  onChange: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.getChannelByProject && _ctx.getChannelByProject(...args)))
                }, [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.projectList, (item, itemIndex) => {
                    return (_openBlock(), _createBlock("option", {
                      value: item.uuid,
                      key: itemIndex
                    }, _toDisplayString(item.name), 9, ["value"]))
                  }), 128))
                ], 40, ["disabled"]), [
                  [_vModelSelect, _ctx.state.filter.projectId]
                ])
              ])
            ]),
            _createVNode("div", _hoisted_13, [
              _createVNode("div", _hoisted_14, [
                _createVNode("label", _hoisted_15, _toDisplayString(_ctx.$t('channels')), 1),
                _withDirectives(_createVNode("select", {
                  disabled: !_ctx.state.filter.projectId,
                  class: "custom-select form-control",
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.state.filter.channelId = $event)),
                  onChange: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.getAccountFormList && _ctx.getAccountFormList(...args)))
                }, [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.channelList, (channel, channelIndex) => {
                    return (_openBlock(), _createBlock("option", {
                      value: channel.uuid,
                      key: channelIndex
                    }, _toDisplayString(channel.name), 9, ["value"]))
                  }), 128))
                ], 40, ["disabled"]), [
                  [_vModelSelect, _ctx.state.filter.channelId]
                ])
              ])
            ]),
            _createVNode("div", _hoisted_16, [
              _createVNode("div", _hoisted_17, [
                _createVNode("label", _hoisted_18, _toDisplayString(_ctx.$t('sort_by')), 1),
                _withDirectives(_createVNode("select", {
                  class: "custom-select form-control",
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.state.filter.selected = $event)),
                  onChange: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.getAccountFormList && _ctx.getAccountFormList(...args)))
                }, [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.sortList, (sort, sortIndex) => {
                    return (_openBlock(), _createBlock("option", {
                      value: sort,
                      key: sortIndex
                    }, _toDisplayString(sort.name), 9, ["value"]))
                  }), 128))
                ], 544), [
                  [_vModelSelect, _ctx.state.filter.selected]
                ])
              ])
            ])
          ]),
          _createVNode("div", _hoisted_19, [
            (_ctx.state.data.tagList.length > 0)
              ? (_openBlock(), _createBlock("p", _hoisted_20, [
                  _createTextVNode(_toDisplayString(_ctx.$t('popular_tags')) + " : ", 1),
                  _createVNode("a", {
                    href: "javscript:void()",
                    class: _ctx.state.filter.tag === 'all' ? 'tags selected-tag' : 'tags',
                    onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.serarchTag('all')))
                  }, _toDisplayString(_ctx.$t('all')), 3),
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.data.tagList, (tag, tagIndex) => {
                    return (_openBlock(), _createBlock("span", { key: tagIndex }, [
                      _createVNode("a", {
                        class: _ctx.state.filter.tag === tag.tags ? 'tags selected-tag' : 'tags',
                        href: "javscript:void()",
                        onClick: ($event: any) => (_ctx.serarchTag(tag.tags))
                      }, _toDisplayString(tag.tags) + " (" + _toDisplayString(tag.myCount) + ") ", 11, ["onClick"])
                    ]))
                  }), 128))
                ]))
              : _createCommentVNode("", true)
          ]),
          _hoisted_21,
          _createVNode("h1", _hoisted_22, _toDisplayString(_ctx.$t('display_form')), 1),
          _createVNode("div", _hoisted_23, [
            _createVNode("div", _hoisted_24, [
              _createVNode("div", _hoisted_25, [
                _withDirectives(_createVNode("input", {
                  type: "radio",
                  id: "all",
                  name: "gender",
                  value: "all",
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_ctx.state.filter.type = $event)),
                  onChange: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.getAccountFormList && _ctx.getAccountFormList(...args)))
                }, null, 544), [
                  [_vModelRadio, _ctx.state.filter.type]
                ]),
                _createVNode("label", _hoisted_26, _toDisplayString(_ctx.$t('all')), 1)
              ])
            ]),
            _createVNode("div", _hoisted_27, [
              _createVNode("div", _hoisted_28, [
                _withDirectives(_createVNode("input", {
                  type: "radio",
                  id: "sent_by_me",
                  name: "gender",
                  value: "sent_by_me",
                  "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (_ctx.state.filter.type = $event)),
                  onChange: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.getAccountFormList && _ctx.getAccountFormList(...args)))
                }, null, 544), [
                  [_vModelRadio, _ctx.state.filter.type]
                ]),
                _createVNode("label", _hoisted_29, _toDisplayString(_ctx.$t('sent_by_me')), 1)
              ])
            ]),
            _createVNode("div", _hoisted_30, [
              _createVNode("div", _hoisted_31, [
                _withDirectives(_createVNode("input", {
                  type: "radio",
                  id: "sent_to_me",
                  name: "gender",
                  value: "sent_to_me",
                  "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => (_ctx.state.filter.type = $event)),
                  onChange: _cache[15] || (_cache[15] = 
//@ts-ignore
(...args) => (_ctx.getAccountFormList && _ctx.getAccountFormList(...args)))
                }, null, 544), [
                  [_vModelRadio, _ctx.state.filter.type]
                ]),
                _createVNode("label", _hoisted_32, _toDisplayString(_ctx.$t('sent_to_me')), 1)
              ])
            ])
          ])
        ]),
        _createVNode("div", _hoisted_33, [
          _createVNode("div", _hoisted_34, [
            _createVNode("h1", _hoisted_35, _toDisplayString(_ctx.$t('forms')), 1)
          ]),
          _createVNode("div", _hoisted_36, [
            _createVNode("div", _hoisted_37, [
              _createVNode("a", {
                onClick: _cache[16] || (_cache[16] = 
//@ts-ignore
(...args) => (_ctx.redirectToCreateForm && _ctx.redirectToCreateForm(...args))),
                id: "createFormInFormList",
                href: "javascript:void(0)",
                class: "btn default-btn d-inline-block mb-0"
              }, [
                _hoisted_38,
                _createTextVNode(" " + _toDisplayString(_ctx.$t('create_form')), 1)
              ])
            ])
          ])
        ]),
        _createVNode("div", _hoisted_39, [
          _createVNode("table", _hoisted_40, [
            _createVNode("thead", _hoisted_41, [
              _createVNode("tr", null, [
                _createVNode("th", _hoisted_42, _toDisplayString(_ctx.$t('form_name')), 1),
                _createVNode("th", _hoisted_43, _toDisplayString(_ctx.$t('send_to_users')), 1),
                _createVNode("th", _hoisted_44, _toDisplayString(_ctx.$t('created_date')), 1),
                _createVNode("th", _hoisted_45, _toDisplayString(_ctx.$t('updated_date')), 1),
                _createVNode("th", _hoisted_46, _toDisplayString(_ctx.$t('action')), 1)
              ])
            ]),
            (_ctx.templateList)
              ? (_openBlock(), _createBlock("tbody", _hoisted_47, [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.templateList, (form, formIndex) => {
                    return (_openBlock(), _createBlock("tr", { key: formIndex }, [
                      _createVNode("td", null, [
                        _createVNode("div", null, [
                          _createVNode("h5", null, [
                            (form.edoc_id)
                              ? (_openBlock(), _createBlock("a", _hoisted_48, [
                                  _hoisted_49,
                                  _createTextVNode(_toDisplayString(form.title), 1)
                                ]))
                              : (_openBlock(), _createBlock("a", _hoisted_50, _toDisplayString(form.title), 1))
                          ])
                        ]),
                        _createVNode("div", null, [
                          _createVNode("p", null, _toDisplayString(form.description), 1)
                        ])
                      ]),
                      _createVNode("td", null, [
                        _createVNode("div", _hoisted_51, [
                          (form.sentToUsers && form.sentToUsers.length)
                            ? (_openBlock(), _createBlock("ul", _hoisted_52, [
                                (_openBlock(true), _createBlock(_Fragment, null, _renderList(form.sentToUsers, (user, userIndex) => {
                                  return (_openBlock(), _createBlock("li", {
                                    class: "active",
                                    key: userIndex
                                  }, [
                                    _createTextVNode(_toDisplayString(user.email), 1),
                                    (userIndex < form.sentToUsers.length - 1)
                                      ? (_openBlock(), _createBlock("span", _hoisted_53, ", "))
                                      : _createCommentVNode("", true)
                                  ]))
                                }), 128))
                              ]))
                            : _createCommentVNode("", true)
                        ])
                      ]),
                      _createVNode("td", null, [
                        _createVNode("p", null, _toDisplayString(_ctx.formatDate(form.created_date)), 1)
                      ]),
                      _createVNode("td", null, [
                        _createVNode("p", null, _toDisplayString(_ctx.formatDate(form.updated_date)), 1)
                      ]),
                      _createVNode("td", null, [
                        _createVNode("div", _hoisted_54, [
                          (form.elements && form.elements.length)
                            ? (_openBlock(), _createBlock("a", {
                                key: 0,
                                title: "Edit",
                                onClick: ($event: any) => (_ctx.editSelectedForm(form)),
                                href: "javascript:void(0)",
                                class: "btn edit-btn mr-1"
                              }, [
                                _hoisted_55,
                                _createTextVNode(" " + _toDisplayString(_ctx.$t('edit')), 1)
                              ], 8, ["onClick"]))
                            : _createCommentVNode("", true),
                          _createVNode("a", {
                            title: "Send to",
                            onClick: ($event: any) => (_ctx.sendSelectedForm(form)),
                            href: "javascript:void(0)",
                            class: "btn send-btn mr-1"
                          }, [
                            _hoisted_56,
                            _createTextVNode(" " + _toDisplayString(_ctx.$t('send')), 1)
                          ], 8, ["onClick"]),
                          _createVNode("a", {
                            title: "View",
                            href: "javascript:void(0)",
                            class: "btn view-btn mr-0",
                            onClick: ($event: any) => (_ctx.selectForm(form))
                          }, [
                            _hoisted_57,
                            _createTextVNode(" " + _toDisplayString(_ctx.$t('view_details')), 1)
                          ], 8, ["onClick"])
                        ])
                      ])
                    ]))
                  }), 128))
                ]))
              : (_openBlock(), _createBlock(_component_EmptyData, {
                  key: 1,
                  title: _ctx.state.data.title,
                  heading: _ctx.state.data.heading
                }, null, 8, ["title", "heading"]))
          ])
        ]),
        _createVNode("div", _hoisted_58, [
          _createVNode("nav", _hoisted_59, [
            _createVNode(_component_v_pagination, {
              modelValue: _ctx.state.item.paging.getAccountFormList.currentPage,
              "onUpdate:modelValue": [
                _cache[17] || (_cache[17] = ($event: any) => (_ctx.state.item.paging.getAccountFormList.currentPage = $event)),
                _ctx.nextPage
              ],
              pages: _ctx.state.item.paging.getAccountFormList.totalPages,
              "range-size": 1,
              "active-color": "#DCEDFF"
            }, null, 8, ["modelValue", "pages", "onUpdate:modelValue"])
          ])
        ])
      ]),
      _createVNode("div", _hoisted_60, [
        _createVNode("div", _hoisted_61, [
          _createVNode("div", _hoisted_62, [
            _createVNode("div", _hoisted_63, [
              _createVNode("div", _hoisted_64, [
                _createVNode("div", _hoisted_65, [
                  _createVNode("h5", _hoisted_66, _toDisplayString(_ctx.state.newFormData.title), 1),
                  _createVNode("p", _hoisted_67, _toDisplayString(_ctx.state.newFormData.description), 1)
                ]),
                _createVNode("button", {
                  type: "button",
                  class: "close",
                  "aria-label": "Close",
                  onClick: _cache[18] || (_cache[18] = 
//@ts-ignore
(...args) => (_ctx.hideTemplateModal && _ctx.hideTemplateModal(...args)))
                }, [
                  _hoisted_68
                ])
              ]),
              _createVNode("div", _hoisted_69, [
                _createVNode("div", _hoisted_70, [
                  _createVNode("form", null, [
                    _createVNode("fieldset", _hoisted_71, [
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.newFormData
                  .elements, (element, elementIndex) => {
                        return (_openBlock(), _createBlock("div", {
                          class: "form-group",
                          key: elementIndex
                        }, [
                          (element.type === 'title')
                            ? (_openBlock(), _createBlock(_component_TitleComponent, {
                                key: 0,
                                title: element.title,
                                description: element.description,
                                editStatus: false
                              }, null, 8, ["title", "description"]))
                            : _createCommentVNode("", true),
                          (element.type === 'textbox')
                            ? (_openBlock(), _createBlock(_component_TextBoxComponent, {
                                key: 1,
                                data: element,
                                editStatus: false
                              }, null, 8, ["data"]))
                            : _createCommentVNode("", true),
                          (element.type === 'radioButton')
                            ? (_openBlock(), _createBlock(_component_RadioButtonComponent, {
                                key: 2,
                                data: element,
                                editStatus: false
                              }, null, 8, ["data"]))
                            : _createCommentVNode("", true),
                          (element.type === 'single_select')
                            ? (_openBlock(), _createBlock(_component_SelectOption, {
                                key: 3,
                                data: element,
                                editStatus: false
                              }, null, 8, ["data"]))
                            : _createCommentVNode("", true),
                          (element.type === 'checkBox')
                            ? (_openBlock(), _createBlock(_component_CheckBox, {
                                key: 4,
                                data: element,
                                editStatus: false
                              }, null, 8, ["data"]))
                            : _createCommentVNode("", true),
                          (element.type === 'textArea')
                            ? (_openBlock(), _createBlock(_component_TextArea, {
                                key: 5,
                                data: element,
                                editStatus: false
                              }, null, 8, ["data"]))
                            : _createCommentVNode("", true),
                          (element.type === 'datePicker')
                            ? (_openBlock(), _createBlock("div", _hoisted_72, [
                                (element.title)
                                  ? (_openBlock(), _createBlock("label", _hoisted_73, _toDisplayString(element.title), 1))
                                  : _createCommentVNode("", true),
                                _createVNode("input", {
                                  type: "text",
                                  class: "form-control",
                                  value: element.date
                                }, null, 8, ["value"])
                              ]))
                            : _createCommentVNode("", true),
                          (element.type === 'digitalSignature')
                            ? (_openBlock(), _createBlock("div", _hoisted_74, [
                                _createVNode("div", _hoisted_75, [
                                  _createVNode("div", _hoisted_76, [
                                    _hoisted_77,
                                    (element.title)
                                      ? (_openBlock(), _createBlock("label", _hoisted_78, _toDisplayString(element.title), 1))
                                      : _createCommentVNode("", true)
                                  ])
                                ])
                              ]))
                            : _createCommentVNode("", true)
                        ]))
                      }), 128))
                    ])
                  ])
                ])
              ]),
              _createVNode("div", _hoisted_79, [
                (_ctx.state.newFormData)
                  ? (_openBlock(), _createBlock("div", _hoisted_80, [
                      _createVNode("p", _hoisted_81, [
                        _hoisted_82,
                        _createTextVNode(" " + _toDisplayString(_ctx.$t('sent_by')) + " : ", 1),
                        (_ctx.state.newFormData.owner &&
                  _ctx.state.newFormData.owner.created_by
                  )
                          ? (_openBlock(), _createBlock("span", _hoisted_83, _toDisplayString(_ctx.state.newFormData.owner.created_by.email), 1))
                          : _createCommentVNode("", true),
                        _createTextVNode(" " + _toDisplayString(_ctx.$t('on')) + " ", 1),
                        _createVNode("span", null, _toDisplayString(_ctx.state.newFormData.created_date), 1)
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _createVNode("button", {
                  type: "button",
                  class: "btn secondary-btn",
                  onClick: _cache[19] || (_cache[19] = 
//@ts-ignore
(...args) => (_ctx.hideTemplateModal && _ctx.hideTemplateModal(...args)))
                }, _toDisplayString(_ctx.$t('close')), 1)
              ])
            ])
          ])
        ])
      ])
    ]),
    _createVNode("div", _hoisted_84, [
      _createVNode("div", _hoisted_85, [
        _createVNode("div", _hoisted_86, [
          _createVNode("div", _hoisted_87, [
            _createVNode("div", _hoisted_88, [
              (_ctx.state.selectedElement.type === 'title' ||
                  _ctx.state.selectedElement.type === 'textbox' ||
                  _ctx.state.selectedElement.type === 'textArea'
                  )
                ? (_openBlock(), _createBlock("h5", _hoisted_89, _toDisplayString(_ctx.$t('edit')) + " " + _toDisplayString(_ctx.state.selectedElement.title), 1))
                : (_openBlock(), _createBlock("h5", _hoisted_90, _toDisplayString(_ctx.$t('edit')) + " " + _toDisplayString(_ctx.state.selectedElement.element.title), 1)),
              _createVNode("button", {
                type: "button",
                class: "close",
                onClick: _cache[20] || (_cache[20] = 
//@ts-ignore
(...args) => (_ctx.hideEditCreateNewForm && _ctx.hideEditCreateNewForm(...args))),
                "aria-label": "Close"
              }, [
                _hoisted_91
              ])
            ]),
            _createVNode("div", _hoisted_92, [
              _createVNode("div", _hoisted_93, [
                (_ctx.state.selectedElement.type === 'title')
                  ? (_openBlock(), _createBlock("div", _hoisted_94, [
                      _createVNode("div", _hoisted_95, [
                        _createVNode("label", _hoisted_96, _toDisplayString(_ctx.$t('name_of_the_form')), 1),
                        _withDirectives(_createVNode("input", {
                          type: "text",
                          class: "form-control",
                          id: "inputPassword",
                          placeholder: _ctx.$t('title_here'),
                          "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => (_ctx.state.selectedElement.title = $event))
                        }, null, 8, ["placeholder"]), [
                          [_vModelText, _ctx.state.selectedElement.title]
                        ])
                      ]),
                      _createVNode("div", _hoisted_97, [
                        _createVNode("label", _hoisted_98, _toDisplayString(_ctx.$t('short_description')), 1),
                        _withDirectives(_createVNode("input", {
                          type: "text",
                          class: "form-control",
                          id: "inputPassword",
                          placeholder: _ctx.$t('description_here'),
                          "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => (_ctx.state.selectedElement.description = $event))
                        }, null, 8, ["placeholder"]), [
                          [_vModelText, _ctx.state.selectedElement.description]
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.state.selectedElement.type === 'textbox')
                  ? (_openBlock(), _createBlock("div", _hoisted_99, [
                      _createVNode("div", _hoisted_100, [
                        _createVNode("label", _hoisted_101, _toDisplayString(_ctx.$t('title')), 1),
                        _withDirectives(_createVNode("input", {
                          type: "text",
                          class: "form-control",
                          id: "inputPassword",
                          placeholder: _ctx.$t('title_here'),
                          "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => (_ctx.state.selectedElement.title = $event))
                        }, null, 8, ["placeholder"]), [
                          [_vModelText, _ctx.state.selectedElement.title]
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.state.selectedElement.type === 'textArea')
                  ? (_openBlock(), _createBlock("div", _hoisted_102, [
                      _createVNode("div", _hoisted_103, [
                        _createVNode("label", _hoisted_104, _toDisplayString(_ctx.$t('title')), 1),
                        _withDirectives(_createVNode("input", {
                          "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => (_ctx.state.selectedElement.title = $event)),
                          type: "text",
                          class: "form-control",
                          id: "inputPassword",
                          placeholder: _ctx.$t('title_here')
                        }, null, 8, ["placeholder"]), [
                          [_vModelText, _ctx.state.selectedElement.title]
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.state.selectedElement.type === 'checkBox')
                  ? (_openBlock(), _createBlock("div", _hoisted_105, [
                      _createVNode("div", _hoisted_106, [
                        _createVNode("div", _hoisted_107, [
                          _createVNode("label", _hoisted_108, _toDisplayString(_ctx.$t('title')), 1),
                          _withDirectives(_createVNode("input", {
                            type: "text",
                            class: "form-control",
                            id: "inputPassword",
                            placeholder: _ctx.$t('text_field_label'),
                            "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => (_ctx.state.selectedElement.element.title = $event))
                          }, null, 8, ["placeholder"]), [
                            [_vModelText, _ctx.state.selectedElement.element.title]
                          ])
                        ]),
                        (_ctx.state.selectedElement.element.select_values &&
                  _ctx.state.selectedElement.element.select_values.length
                  )
                          ? (_openBlock(), _createBlock("div", _hoisted_109, [
                              _createVNode("label", _hoisted_110, _toDisplayString(_ctx.$t('options')), 1),
                              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.selectedElement.element
                  .select_values, (row, rowIndex) => {
                                return (_openBlock(), _createBlock("div", {
                                  class: "row py-2",
                                  key: rowIndex
                                }, [
                                  _createVNode("div", _hoisted_111, [
                                    _createVNode("div", _hoisted_112, [
                                      _withDirectives(_createVNode("input", {
                                        class: "form-check-input",
                                        type: "radio",
                                        name: "exampleRadios",
                                        id: "exampleRadios1",
                                        "onUpdate:modelValue": ($event: any) => (row.selected = $event)
                                      }, null, 8, ["onUpdate:modelValue"]), [
                                        [_vModelRadio, row.selected]
                                      ])
                                    ])
                                  ]),
                                  _createVNode("div", _hoisted_113, [
                                    _withDirectives(_createVNode("input", {
                                      type: "text",
                                      class: "form-control",
                                      placeholder: "Option label",
                                      "onUpdate:modelValue": ($event: any) => (row.text = $event)
                                    }, null, 8, ["onUpdate:modelValue"]), [
                                      [_vModelText, row.text]
                                    ])
                                  ]),
                                  _createVNode("div", _hoisted_114, [
                                    _withDirectives(_createVNode("input", {
                                      type: "text",
                                      class: "form-control",
                                      placeholder: "Option value",
                                      "onUpdate:modelValue": ($event: any) => (row.value = $event)
                                    }, null, 8, ["onUpdate:modelValue"]), [
                                      [_vModelText, row.value]
                                    ])
                                  ]),
                                  _createVNode("div", _hoisted_115, [
                                    _createVNode("button", {
                                      type: "button",
                                      class: "option-btn",
                                      disabled: _ctx.state.selectedElement.element.select_values
                  .length === 1
                  ,
                                      onClick: ($event: any) => (_ctx.removeCheckBoxinCustomEdit(row.text))
                                    }, [
                                      _hoisted_116
                                    ], 8, ["disabled", "onClick"])
                                  ])
                                ]))
                              }), 128)),
                              _createVNode("div", _hoisted_117, [
                                _createVNode("a", {
                                  href: "javascript:void(0)",
                                  onClick: _cache[26] || (_cache[26] = 
//@ts-ignore
(...args) => (_ctx.addCheckBoxinCustomEdit && _ctx.addCheckBoxinCustomEdit(...args))),
                                  class: "btn default-btn outline secondary mt-3"
                                }, [
                                  _hoisted_118,
                                  _createTextVNode(" " + _toDisplayString(_ctx.$t('add_option')), 1)
                                ])
                              ])
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.state.selectedElement.type === 'single_select')
                  ? (_openBlock(), _createBlock("div", _hoisted_119, [
                      _createVNode("div", _hoisted_120, [
                        _createVNode("div", _hoisted_121, [
                          _createVNode("label", _hoisted_122, _toDisplayString(_ctx.$t('title')), 1),
                          _withDirectives(_createVNode("input", {
                            type: "text",
                            class: "form-control",
                            id: "inputPassword",
                            placeholder: _ctx.$t('text_field_label'),
                            "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => (_ctx.state.selectedElement.element.title = $event))
                          }, null, 8, ["placeholder"]), [
                            [_vModelText, _ctx.state.selectedElement.element.title]
                          ])
                        ]),
                        (_ctx.state.selectedElement.element.select_values &&
                  _ctx.state.selectedElement.element.select_values.length
                  )
                          ? (_openBlock(), _createBlock("div", _hoisted_123, [
                              _createVNode("label", _hoisted_124, _toDisplayString(_ctx.$t('options')), 1),
                              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.selectedElement.element
                  .select_values, (row, rowIndex) => {
                                return (_openBlock(), _createBlock("div", {
                                  class: "row py-2",
                                  key: rowIndex
                                }, [
                                  _createVNode("div", _hoisted_125, [
                                    _createVNode("div", _hoisted_126, [
                                      _withDirectives(_createVNode("input", {
                                        class: "form-check-input",
                                        type: "radio",
                                        name: "exampleRadios",
                                        id: "exampleRadios1",
                                        "onUpdate:modelValue": ($event: any) => (row.selected = $event)
                                      }, null, 8, ["onUpdate:modelValue"]), [
                                        [_vModelRadio, row.selected]
                                      ])
                                    ])
                                  ]),
                                  _createVNode("div", _hoisted_127, [
                                    _withDirectives(_createVNode("input", {
                                      type: "text",
                                      class: "form-control",
                                      placeholder: "Option label",
                                      "onUpdate:modelValue": ($event: any) => (row.text = $event)
                                    }, null, 8, ["onUpdate:modelValue"]), [
                                      [_vModelText, row.text]
                                    ])
                                  ]),
                                  _createVNode("div", _hoisted_128, [
                                    _withDirectives(_createVNode("input", {
                                      type: "text",
                                      class: "form-control",
                                      placeholder: "Option value",
                                      "onUpdate:modelValue": ($event: any) => (row.value = $event)
                                    }, null, 8, ["onUpdate:modelValue"]), [
                                      [_vModelText, row.value]
                                    ])
                                  ]),
                                  _createVNode("div", _hoisted_129, [
                                    _createVNode("button", {
                                      type: "button",
                                      class: "option-btn",
                                      disabled: _ctx.state.selectedElement.element.select_values
                  .length === 1
                  ,
                                      onClick: ($event: any) => (_ctx.removeSelectOptioninCustomEdit(row.text))
                                    }, [
                                      _hoisted_130
                                    ], 8, ["disabled", "onClick"])
                                  ])
                                ]))
                              }), 128)),
                              _createVNode("div", _hoisted_131, [
                                _createVNode("a", {
                                  href: "javascript:void(0)",
                                  onClick: _cache[28] || (_cache[28] = 
//@ts-ignore
(...args) => (_ctx.addSelectOptionsinCustomEdit && _ctx.addSelectOptionsinCustomEdit(...args))),
                                  class: "btn default-btn outline secondary mt-3"
                                }, [
                                  _hoisted_132,
                                  _createTextVNode(" " + _toDisplayString(_ctx.$t('add_option')), 1)
                                ])
                              ])
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.state.selectedElement.type === 'radioButton')
                  ? (_openBlock(), _createBlock("div", _hoisted_133, [
                      _createVNode("div", _hoisted_134, [
                        _createVNode("div", _hoisted_135, [
                          _createVNode("label", _hoisted_136, _toDisplayString(_ctx.$t('title')), 1),
                          _withDirectives(_createVNode("input", {
                            type: "text",
                            class: "form-control",
                            id: "inputPassword",
                            placeholder: _ctx.$t('text_field_label'),
                            "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => (_ctx.state.selectedElement.element.title = $event))
                          }, null, 8, ["placeholder"]), [
                            [_vModelText, _ctx.state.selectedElement.element.title]
                          ])
                        ]),
                        (_ctx.state.selectedElement.element.select_values &&
                  _ctx.state.selectedElement.element.select_values.length
                  )
                          ? (_openBlock(), _createBlock("div", _hoisted_137, [
                              _createVNode("label", _hoisted_138, _toDisplayString(_ctx.$t('options')), 1),
                              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.selectedElement.element
                  .select_values, (row, rowIndex) => {
                                return (_openBlock(), _createBlock("div", {
                                  class: "row py-2",
                                  key: rowIndex
                                }, [
                                  _createVNode("div", _hoisted_139, [
                                    _createVNode("div", _hoisted_140, [
                                      _withDirectives(_createVNode("input", {
                                        class: "form-check-input",
                                        type: "radio",
                                        name: "exampleRadios",
                                        id: "exampleRadios1",
                                        "onUpdate:modelValue": ($event: any) => (row.selected = $event)
                                      }, null, 8, ["onUpdate:modelValue"]), [
                                        [_vModelRadio, row.selected]
                                      ])
                                    ])
                                  ]),
                                  _createVNode("div", _hoisted_141, [
                                    _withDirectives(_createVNode("input", {
                                      type: "text",
                                      class: "form-control",
                                      placeholder: "Option label",
                                      "onUpdate:modelValue": ($event: any) => (row.text = $event)
                                    }, null, 8, ["onUpdate:modelValue"]), [
                                      [_vModelText, row.text]
                                    ])
                                  ]),
                                  _createVNode("div", _hoisted_142, [
                                    _withDirectives(_createVNode("input", {
                                      type: "text",
                                      class: "form-control",
                                      placeholder: "Option value",
                                      "onUpdate:modelValue": ($event: any) => (row.value = $event)
                                    }, null, 8, ["onUpdate:modelValue"]), [
                                      [_vModelText, row.value]
                                    ])
                                  ]),
                                  _createVNode("div", _hoisted_143, [
                                    _createVNode("button", {
                                      type: "button",
                                      class: "option-btn",
                                      disabled: _ctx.state.selectedElement.element.select_values
                  .length === 1
                  ,
                                      onClick: ($event: any) => (_ctx.removeOptionsinCustomEdit(row.text))
                                    }, [
                                      _hoisted_144
                                    ], 8, ["disabled", "onClick"])
                                  ])
                                ]))
                              }), 128)),
                              _createVNode("div", _hoisted_145, [
                                _createVNode("a", {
                                  href: "javascript:void(0)",
                                  onClick: _cache[30] || (_cache[30] = 
//@ts-ignore
(...args) => (_ctx.addOptionsinCustomEdit && _ctx.addOptionsinCustomEdit(...args))),
                                  class: "btn default-btn outline secondary mt-3"
                                }, [
                                  _hoisted_146,
                                  _createTextVNode(" " + _toDisplayString(_ctx.$t('add_option')), 1)
                                ])
                              ])
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createVNode("div", _hoisted_147, [
              _createVNode("button", {
                type: "button",
                class: "btn secondary-btn",
                onClick: _cache[31] || (_cache[31] = 
//@ts-ignore
(...args) => (_ctx.hideEditCreateNewForm && _ctx.hideEditCreateNewForm(...args)))
              }, _toDisplayString(_ctx.$t('close')), 1),
              _createVNode("button", {
                type: "button",
                class: "btn default-btn",
                onClick: _cache[32] || (_cache[32] = 
//@ts-ignore
(...args) => (_ctx.updateEditNewForm && _ctx.updateEditNewForm(...args)))
              }, _toDisplayString(_ctx.$t('update')), 1)
            ])
          ])
        ])
      ])
    ]),
    _createVNode("div", _hoisted_148, [
      _createVNode("div", _hoisted_149, [
        _createVNode("div", _hoisted_150, [
          _createVNode("div", _hoisted_151, [
            _createVNode("div", _hoisted_152, [
              _createVNode("div", _hoisted_153, [
                _createVNode("h5", _hoisted_154, [
                  _createTextVNode(_toDisplayString(_ctx.state.formData.title) + " ", 1),
                  _createVNode("small", null, " - " + _toDisplayString(_ctx.state.formData.description), 1)
                ])
              ]),
              _createVNode("button", {
                type: "button",
                class: "close",
                onClick: _cache[33] || (_cache[33] = 
//@ts-ignore
(...args) => (_ctx.hideFormView && _ctx.hideFormView(...args))),
                "aria-label": "Close"
              }, [
                _hoisted_155
              ])
            ]),
            _createVNode("div", _hoisted_156, [
              _createVNode("div", _hoisted_157, [
                _createVNode("div", _hoisted_158, [
                  _createVNode("ul", _hoisted_159, [
                    _createVNode("li", _hoisted_160, [
                      _createVNode("a", _hoisted_161, _toDisplayString(_ctx.$t('form')), 1)
                    ]),
                    _createVNode("li", _hoisted_162, [
                      _createVNode("a", _hoisted_163, _toDisplayString(_ctx.$t('response')), 1)
                    ])
                  ]),
                  _createVNode("div", _hoisted_164, [
                    _createVNode("div", _hoisted_165, [
                      _createVNode("form", null, [
                        _createVNode("fieldset", _hoisted_166, [
                          _createVNode("div", _hoisted_167, [
                            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.formData
                  .elements, (element, elementIndex) => {
                              return (_openBlock(), _createBlock("div", {
                                class: "form-group",
                                key: elementIndex
                              }, [
                                (element.type === 'title')
                                  ? (_openBlock(), _createBlock(_component_TitleComponent, {
                                      key: 0,
                                      title: element.title,
                                      description: element.description,
                                      editStatus: false
                                    }, null, 8, ["title", "description"]))
                                  : _createCommentVNode("", true),
                                (element.type === 'textbox')
                                  ? (_openBlock(), _createBlock(_component_TextBoxComponent, {
                                      key: 1,
                                      data: element,
                                      editStatus: false
                                    }, null, 8, ["data"]))
                                  : _createCommentVNode("", true),
                                (element.type === 'radioButton')
                                  ? (_openBlock(), _createBlock(_component_RadioButtonComponent, {
                                      key: 2,
                                      data: element,
                                      editStatus: false
                                    }, null, 8, ["data"]))
                                  : _createCommentVNode("", true),
                                (element.type === 'single_select')
                                  ? (_openBlock(), _createBlock(_component_SelectOption, {
                                      key: 3,
                                      data: element,
                                      editStatus: false
                                    }, null, 8, ["data"]))
                                  : _createCommentVNode("", true),
                                (element.type === 'checkBox')
                                  ? (_openBlock(), _createBlock(_component_CheckBox, {
                                      key: 4,
                                      data: element,
                                      editStatus: false
                                    }, null, 8, ["data"]))
                                  : _createCommentVNode("", true),
                                (element.type === 'textArea')
                                  ? (_openBlock(), _createBlock(_component_TextArea, {
                                      key: 5,
                                      data: element,
                                      editStatus: false
                                    }, null, 8, ["data"]))
                                  : _createCommentVNode("", true)
                              ]))
                            }), 128))
                          ])
                        ])
                      ])
                    ]),
                    _createVNode("div", _hoisted_168, [
                      (_ctx.state.item.selectedUserFormDetails.elements &&
                  _ctx.state.item.selectedUserFormDetails.elements.length
                  )
                        ? (_openBlock(), _createBlock("div", _hoisted_169, [
                            _createVNode("form", null, [
                              _createVNode("fieldset", _hoisted_170, [
                                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.item
                  .selectedUserFormDetails.elements, (element, elementIndex) => {
                                  return (_openBlock(), _createBlock("div", {
                                    class: "form-group",
                                    key: elementIndex
                                  }, [
                                    (element.type === 'title')
                                      ? (_openBlock(), _createBlock(_component_TitleComponent, {
                                          key: 0,
                                          title: element.title,
                                          description: element.description,
                                          editStatus: false
                                        }, null, 8, ["title", "description"]))
                                      : _createCommentVNode("", true),
                                    (element.type === 'textbox')
                                      ? (_openBlock(), _createBlock(_component_TextBoxComponent, {
                                          key: 1,
                                          data: element,
                                          editStatus: false
                                        }, null, 8, ["data"]))
                                      : _createCommentVNode("", true),
                                    (element.type === 'radioButton')
                                      ? (_openBlock(), _createBlock(_component_RadioButtonComponent, {
                                          key: 2,
                                          data: element,
                                          editStatus: false
                                        }, null, 8, ["data"]))
                                      : _createCommentVNode("", true),
                                    (element.type === 'single_select')
                                      ? (_openBlock(), _createBlock(_component_SelectOption, {
                                          key: 3,
                                          data: element,
                                          editStatus: false
                                        }, null, 8, ["data"]))
                                      : _createCommentVNode("", true),
                                    (element.type === 'checkBox')
                                      ? (_openBlock(), _createBlock(_component_CheckBox, {
                                          key: 4,
                                          data: element,
                                          editStatus: false
                                        }, null, 8, ["data"]))
                                      : _createCommentVNode("", true),
                                    (element.type === 'textArea')
                                      ? (_openBlock(), _createBlock(_component_TextArea, {
                                          key: 5,
                                          data: element,
                                          editStatus: false
                                        }, null, 8, ["data"]))
                                      : _createCommentVNode("", true)
                                  ]))
                                }), 128))
                              ])
                            ])
                          ]))
                        : (_openBlock(), _createBlock("div", _hoisted_171, [
                            _createVNode("div", _hoisted_172, [
                              _createVNode("div", _hoisted_173, [
                                _hoisted_174,
                                _createVNode("div", _hoisted_175, [
                                  (_ctx.state.item.selectedUserFormDetails &&
                  !_ctx.state.item.selectedUserFormDetails.length &&
                  _ctx.state.formData.sentToUsers &&
                  !_ctx.state.formData.sentToUsers.length
                  )
                                    ? (_openBlock(), _createBlock("h5", _hoisted_176, _toDisplayString(_ctx.$t('please_choose_user')), 1))
                                    : _createCommentVNode("", true),
                                  (_ctx.state.selectedUser.email != _ctx.state.email &&
                  _ctx.state.item.selectedUserFormDetails &&
                  !_ctx.state.item.selectedUserFormDetails.length &&
                  _ctx.state.formData.sentToUsers &&
                  _ctx.state.formData.sentToUsers.length
                  )
                                    ? (_openBlock(), _createBlock("h5", _hoisted_177, _toDisplayString(_ctx.$t('user_not_filled_form')), 1))
                                    : _createCommentVNode("", true),
                                  (_ctx.state.selectedUser.email === _ctx.state.email &&
                  _ctx.state.item.selectedUserFormDetails &&
                  !_ctx.state.item.selectedUserFormDetails.length
                  )
                                    ? (_openBlock(), _createBlock("h5", _hoisted_178, [
                                        _createTextVNode(_toDisplayString(_ctx.$t('you_not_filled_form')) + " ", 1),
                                        _createVNode("a", {
                                          onClick: _cache[34] || (_cache[34] = 
//@ts-ignore
(...args) => (_ctx.userFormClick && _ctx.userFormClick(...args))),
                                          class: "btn btn-outline-primary btn-sm mx-1 rounded-pill"
                                        }, _toDisplayString(_ctx.$t('click_here')), 1),
                                        _createTextVNode(" " + _toDisplayString(_ctx.$t('to_fill_it')), 1)
                                      ]))
                                    : _createCommentVNode("", true)
                                ])
                              ])
                            ])
                          ]))
                    ])
                  ])
                ]),
                _createVNode("div", _hoisted_179, [
                  _createVNode("div", _hoisted_180, [
                    _createVNode("p", null, [
                      _createVNode("strong", null, _toDisplayString(_ctx.$t('sent_to_users')) + " (" + _toDisplayString(_ctx.sentToUsers.length) + ")", 1)
                    ]),
                    _createVNode("div", _hoisted_181, [
                      _withDirectives(_createVNode("input", {
                        type: "text",
                        class: "form-control",
                        placeholder: _ctx.$t('search_user'),
                        "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event: any) => (_ctx.state.item.searchUser = $event))
                      }, null, 8, ["placeholder"]), [
                        [_vModelText, _ctx.state.item.searchUser]
                      ]),
                      _hoisted_182
                    ])
                  ]),
                  (_ctx.sentToUsers && _ctx.sentToUsers.length)
                    ? (_openBlock(), _createBlock("div", _hoisted_183, [
                        _createVNode("ul", null, [
                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.sentToUsers, (user, userIndex) => {
                            return (_openBlock(), _createBlock("li", {
                              class: _ctx.state.activeUserIndex === userIndex ? 'active' : ''
                  ,
                              key: userIndex,
                              onClick: ($event: any) => (
                  _ctx.getAccountFormResponseByEmailAndId(user, userIndex)
                  )
                            }, [
                              _createVNode("div", _hoisted_184, [
                                _createVNode("div", null, [
                                  (user.image)
                                    ? (_openBlock(), _createBlock("img", {
                                        key: 0,
                                        src: user.image,
                                        alt: ""
                                      }, null, 8, ["src"]))
                                    : (_openBlock(), _createBlock("img", _hoisted_185))
                                ]),
                                _createVNode("h5", null, _toDisplayString(user.email), 1)
                              ])
                            ], 10, ["onClick"]))
                          }), 128))
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ])
              ])
            ]),
            _createVNode("div", _hoisted_186, [
              _createVNode("div", _hoisted_187, [
                _createVNode("p", _hoisted_188, [
                  _hoisted_189,
                  _createTextVNode(" " + _toDisplayString(_ctx.$t('sent_by')) + " : ", 1),
                  _createVNode("span", null, _toDisplayString(_ctx.state.name), 1),
                  _createTextVNode(" " + _toDisplayString(_ctx.$t('on')) + " ", 1),
                  _hoisted_190
                ])
              ]),
              _createVNode("button", {
                type: "button",
                class: "btn secondary-btn",
                onClick: _cache[36] || (_cache[36] = 
//@ts-ignore
(...args) => (_ctx.hideFormView && _ctx.hideFormView(...args)))
              }, _toDisplayString(_ctx.$t('close')), 1)
            ])
          ])
        ])
      ]),
      _createVNode("div", _hoisted_191, [
        _createVNode("div", _hoisted_192, [
          _createVNode("div", _hoisted_193, [
            _createVNode("div", _hoisted_194, [
              _createVNode("div", _hoisted_195, [
                _createVNode("h5", _hoisted_196, [
                  _createTextVNode(_toDisplayString(_ctx.state.formData.title) + " ", 1),
                  _createVNode("small", null, " - " + _toDisplayString(_ctx.state.formData.description), 1)
                ]),
                _hoisted_197
              ]),
              _createVNode("div", _hoisted_198, [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.userFormData, (element, elementIndex) => {
                  return (_openBlock(), _createBlock("div", {
                    class: "form-wrap pt-0",
                    key: elementIndex
                  }, [
                    _createVNode("div", _hoisted_199, [
                      (element.type === 'title')
                        ? (_openBlock(), _createBlock(_component_TitleComponent, {
                            key: 0,
                            title: element.title,
                            description: element.description,
                            editStatus: false
                          }, null, 8, ["title", "description"]))
                        : _createCommentVNode("", true)
                    ]),
                    (element.type === 'textbox')
                      ? (_openBlock(), _createBlock("div", _hoisted_200, [
                          _createVNode("label", _hoisted_201, _toDisplayString(element.title), 1),
                          _withDirectives(_createVNode("input", {
                            type: "text",
                            class: "form-control",
                            placeholder: element.placeholder,
                            "onUpdate:modelValue": ($event: any) => (element.answer = $event)
                          }, null, 8, ["placeholder", "onUpdate:modelValue"]), [
                            [_vModelText, element.answer]
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (element.type === 'radioButton')
                      ? (_openBlock(), _createBlock("div", _hoisted_202, [
                          _createVNode("label", _hoisted_203, _toDisplayString(element.title), 1),
                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(element.select_values, (option, optionIndex) => {
                            return (_openBlock(), _createBlock("div", { key: optionIndex }, [
                              _withDirectives(_createVNode("input", {
                                type: "radio",
                                name: "radioName",
                                value: option.value,
                                "onUpdate:modelValue": ($event: any) => (option.selected = $event),
                                onChange: ($event: any) => (_ctx.radioChange(element, option))
                              }, null, 40, ["value", "onUpdate:modelValue", "onChange"]), [
                                [_vModelRadio, option.selected]
                              ]),
                              _createVNode("label", null, _toDisplayString(option.text), 1)
                            ]))
                          }), 128))
                        ]))
                      : _createCommentVNode("", true),
                    (element.type === 'single_select')
                      ? (_openBlock(), _createBlock("div", _hoisted_204, [
                          _createVNode("label", _hoisted_205, _toDisplayString(element.title), 1),
                          _withDirectives(_createVNode("select", {
                            id: "cars",
                            class: "form-control",
                            "onUpdate:modelValue": ($event: any) => (element.selectedOption = $event)
                          }, [
                            (_openBlock(true), _createBlock(_Fragment, null, _renderList(element.select_values, (option, optionIndex) => {
                              return (_openBlock(), _createBlock("option", {
                                value: option,
                                key: optionIndex
                              }, _toDisplayString(option.text), 9, ["value"]))
                            }), 128))
                          ], 8, ["onUpdate:modelValue"]), [
                            [_vModelSelect, element.selectedOption]
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (element.type === 'checkBox')
                      ? (_openBlock(), _createBlock("div", _hoisted_206, [
                          _createVNode("label", null, _toDisplayString(element.title), 1),
                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(element.select_values, (option, optionIndex) => {
                            return (_openBlock(), _createBlock("div", { key: optionIndex }, [
                              _withDirectives(_createVNode("input", {
                                type: "checkbox",
                                id: "vehicle1",
                                name: "vehicle1",
                                value: option.text,
                                "onUpdate:modelValue": ($event: any) => (option.selected = $event)
                              }, null, 8, ["value", "onUpdate:modelValue"]), [
                                [_vModelCheckbox, option.selected]
                              ]),
                              _createVNode("label", _hoisted_207, _toDisplayString(option.text), 1)
                            ]))
                          }), 128))
                        ]))
                      : _createCommentVNode("", true),
                    (element.type === 'textArea')
                      ? (_openBlock(), _createBlock("div", _hoisted_208, [
                          _createVNode("label", null, _toDisplayString(element.title), 1),
                          _withDirectives(_createVNode("textarea", {
                            class: "form-control",
                            id: "w3review",
                            name: "w3review",
                            rows: "4",
                            cols: "50",
                            "onUpdate:modelValue": ($event: any) => (element.answer = $event)
                          }, null, 8, ["onUpdate:modelValue"]), [
                            [_vModelText, element.answer]
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                }), 128))
              ]),
              _createVNode("div", _hoisted_209, [
                _createVNode("button", {
                  type: "button",
                  class: "btn default-btn",
                  onClick: _cache[37] || (_cache[37] = 
//@ts-ignore
(...args) => (_ctx.selectedUserAccountFormResponse && _ctx.selectedUserAccountFormResponse(...args)))
                }, _toDisplayString(_ctx.state.ui.isPostLoading.selectedUserAccountFormResponse
                    ? _ctx.$t('submitting')
                    : _ctx.$t('submit_form')), 1),
                _createVNode("button", _hoisted_210, _toDisplayString(_ctx.$t('close')), 1)
              ])
            ])
          ])
        ])
      ])
    ]),
    _createVNode("div", _hoisted_211, [
      _createVNode("div", _hoisted_212, [
        _createVNode("div", _hoisted_213, [
          _createVNode("div", _hoisted_214, [
            _createVNode("div", _hoisted_215, [
              _createVNode("div", {
                class: "modal-back-btn",
                onClick: _cache[38] || (_cache[38] = 
//@ts-ignore
(...args) => (_ctx.sendOptionBack && _ctx.sendOptionBack(...args)))
              }, [
                _hoisted_216
              ]),
              _createVNode("div", _hoisted_217, [
                _createVNode("h5", _hoisted_218, _toDisplayString(_ctx.$t('send_option')), 1)
              ]),
              _createVNode("button", {
                type: "button",
                class: "close",
                "data-dismiss": "modal",
                onClick: _cache[39] || (_cache[39] = 
//@ts-ignore
(...args) => (_ctx.hideSendOptionModal && _ctx.hideSendOptionModal(...args))),
                "aria-label": "Close"
              }, [
                _hoisted_219
              ])
            ]),
            _createVNode("div", _hoisted_220, [
              _createVNode(_component_ErrorList, {
                errors: _ctx.state.item.error.erorListSendForm,
                hasError: _ctx.state.item.hasError
              }, null, 8, ["errors", "hasError"]),
              _createVNode("div", _hoisted_221, [
                _createVNode("div", _hoisted_222, [
                  _createVNode("label", _hoisted_223, _toDisplayString(_ctx.$t('select_project')), 1),
                  _withDirectives(_createVNode("select", {
                    disabled: !_ctx.state.projectList || !_ctx.state.projectList.length,
                    class: "custom-select form-control",
                    "onUpdate:modelValue": _cache[40] || (_cache[40] = ($event: any) => (_ctx.state.item.sendOption.project = $event)),
                    onChange: _cache[41] || (_cache[41] = 
//@ts-ignore
(...args) => (_ctx.getChannelByProjectForSendOption && _ctx.getChannelByProjectForSendOption(...args)))
                  }, [
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.projectList, (item, itemIndex) => {
                      return (_openBlock(), _createBlock("option", {
                        value: item,
                        key: itemIndex
                      }, _toDisplayString(item.name), 9, ["value"]))
                    }), 128))
                  ], 40, ["disabled"]), [
                    [_vModelSelect, _ctx.state.item.sendOption.project]
                  ])
                ]),
                _createVNode("div", _hoisted_224, [
                  _createVNode("label", _hoisted_225, _toDisplayString(_ctx.$t('select_channel')), 1),
                  _withDirectives(_createVNode("select", {
                    disabled: !_ctx.state.channelListForSendOption ||
                  !_ctx.state.channelListForSendOption.length
                  ,
                    class: "custom-select form-control",
                    "onUpdate:modelValue": _cache[42] || (_cache[42] = ($event: any) => (_ctx.state.item.sendOption.channel = $event)),
                    onChange: _cache[43] || (_cache[43] = 
//@ts-ignore
(...args) => (_ctx.getUserListByProjectAndChannel && _ctx.getUserListByProjectAndChannel(...args)))
                  }, [
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.channelListForSendOption, (item, itemIndex) => {
                      return (_openBlock(), _createBlock("option", {
                        value: item,
                        key: itemIndex
                      }, _toDisplayString(item.name), 9, ["value"]))
                    }), 128))
                  ], 40, ["disabled"]), [
                    [_vModelSelect, _ctx.state.item.sendOption.channel]
                  ])
                ]),
                _createVNode("div", _hoisted_226, [
                  _createVNode("label", _hoisted_227, _toDisplayString(_ctx.$t('choose_member')), 1),
                  _withDirectives(_createVNode("select", {
                    disabled: !_ctx.state.userListForSendOption ||
                  !_ctx.state.userListForSendOption.length
                  ,
                    class: "form-control mb-2",
                    id: "",
                    "onUpdate:modelValue": _cache[44] || (_cache[44] = ($event: any) => (_ctx.state.existingMember = $event)),
                    onChange: _cache[45] || (_cache[45] = 
//@ts-ignore
(...args) => (_ctx.changeExistingMemberInSendOption && _ctx.changeExistingMemberInSendOption(...args)))
                  }, [
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.userListForSendOption, (item, itemIndex) => {
                      return (_openBlock(), _createBlock("option", {
                        value: item,
                        key: itemIndex
                      }, _toDisplayString(item.full_name) + " (" + _toDisplayString(item.email) + ") ", 9, ["value"]))
                    }), 128))
                  ], 40, ["disabled"]), [
                    [_vModelSelect, _ctx.state.existingMember]
                  ]),
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.invite.users, (user, userIndex) => {
                    return (_openBlock(), _createBlock("div", {
                      class: "email-tag",
                      key: userIndex
                    }, [
                      _createVNode("p", _hoisted_228, [
                        _createTextVNode(_toDisplayString(user.full_name) + " (" + _toDisplayString(user.email) + ") ", 1),
                        _createVNode("a", {
                          href: "javascript:void(0)",
                          onClick: ($event: any) => (_ctx.removeSelectedMember(user))
                        }, [
                          _hoisted_229
                        ], 8, ["onClick"])
                      ])
                    ]))
                  }), 128))
                ]),
                _createVNode("div", _hoisted_230, [
                  _createVNode("label", _hoisted_231, _toDisplayString(_ctx.$t('additional_message')), 1),
                  _withDirectives(_createVNode("textarea", {
                    class: "form-control",
                    id: "w3review",
                    name: "w3review",
                    rows: "4",
                    cols: "50",
                    "onUpdate:modelValue": _cache[46] || (_cache[46] = ($event: any) => (_ctx.state.data.additionalMessage = $event))
                  }, null, 512), [
                    [_vModelText, _ctx.state.data.additionalMessage]
                  ])
                ])
              ])
            ]),
            _createVNode("div", _hoisted_232, [
              _createVNode("div", _hoisted_233, [
                _createVNode("div", _hoisted_234, [
                  _createVNode("div", _hoisted_235, [
                    _createVNode("label", _hoisted_236, [
                      _hoisted_237,
                      _createTextVNode(" " + _toDisplayString(_ctx.$t('share_this_form')) + " : ", 1)
                    ]),
                    (_ctx.state.data.privacyList && _ctx.state.data.privacyList.length
                  )
                      ? (_openBlock(), _createBlock("div", _hoisted_238, [
                          _withDirectives(_createVNode("select", {
                            class: "custom-select form-control",
                            "onUpdate:modelValue": _cache[47] || (_cache[47] = ($event: any) => (_ctx.state.data.privacy = $event))
                          }, [
                            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.data.privacyList, (item, itemIndex) => {
                              return (_openBlock(), _createBlock("option", {
                                value: item,
                                key: itemIndex
                              }, _toDisplayString(item.name), 9, ["value"]))
                            }), 128))
                          ], 512), [
                            [_vModelSelect, _ctx.state.data.privacy]
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    _createVNode("div", _hoisted_239, [
                      _hoisted_240,
                      _createVNode("div", _hoisted_241, [
                        _createVNode("h5", null, _toDisplayString(_ctx.state.data.privacy.value), 1),
                        _createVNode("p", _hoisted_242, _toDisplayString(_ctx.formPrivacyMessage), 1)
                      ])
                    ])
                  ])
                ]),
                _createVNode("div", _hoisted_243, [
                  _createVNode("div", _hoisted_244, [
                    _createVNode("button", {
                      type: "button",
                      class: "btn default-btn",
                      onClick: _cache[48] || (_cache[48] = 
//@ts-ignore
(...args) => (_ctx.sendDigitizedForm && _ctx.sendDigitizedForm(...args)))
                    }, _toDisplayString(_ctx.state.ui.isPostLoading.sendDigitizedForm ? _ctx.$t('sending') : _ctx.$t('send')), 1),
                    _createVNode("button", {
                      type: "button",
                      class: "btn secondary-btn",
                      "data-dismiss": "modal",
                      onClick: _cache[49] || (_cache[49] = 
//@ts-ignore
(...args) => (_ctx.hideSendOptionModal && _ctx.hideSendOptionModal(...args)))
                    }, _toDisplayString(_ctx.$t('cancel')), 1)
                  ])
                ])
              ])
            ])
          ])
        ])
      ])
    ]),
    (_ctx.state.ui.isActive.upgradeSubscription)
      ? (_openBlock(), _createBlock(_component_UpgradeSubscriptionModal, {
          key: 0,
          onCloseModal: _ctx.hideUpdateSubscriptionModal
        }, null, 8, ["onCloseModal"]))
      : _createCommentVNode("", true)
  ]))
}